module.exports = __webpack_public_path__ + "img/_Large-Semi-Elliptical-Attachment-L.480bc93e.jpg";